import { defineStore } from 'pinia';

interface DebugState {
  enabled: boolean;
}

export const useDebugStore = defineStore('debug', {
  state: (): DebugState => ({
    enabled: false,
  }),
  actions: {
    setEnabled(value: boolean) {
      this.enabled = value;
    },
  },
});
